// extracted by mini-css-extract-plugin
module.exports = {"animated_background":"getImgFood_animated_background__3RDLH","placeHolderShimmer":"getImgFood_placeHolderShimmer__dM8re"};